import {
  SET_HIDDEN,
  FETCHED_DEMAND_OFFERS,
  FETCHED_SUB_DEMAND_OFFERS,
  FETCHED_STATS,
  FETCHED_SUB_HISTORY
} from '../types';
import {lowestDenom,pairs} from '../../config';

export function collateralizeFilterDispatch() {
  return (dispatch,getState) => collateralizeFilter(dispatch,getState())
}

export function collateralizeFilter(dispatch,state){
  try {
    let bids = [];
    let asks = [];
    let {denomination,asset,type} = state.ui_marketplace.market;

    state.orderbook.pairs[state.ui_marketplace.market.type].forEach((pair)=>{
      if(pair.denomination == denomination && pair.asset == asset) {
        bids = pair.bids;
        asks = pair.asks;
      }
    })
    // let earliestSettleBlock = 450 * Math.max(0,state.settings.settings.settleWindowTaker) + state.socket.bcHeight;
    //TODO ARJUN
    let earliestSettleBlock = 0;

    let collateral = state.ui_marketplace.collateral;

    let obj = combine(asks,0,collateral,denomination.toLowerCase(),earliestSettleBlock);
    let hidden = obj.hidden;
    let filterOffers = obj.orders.sort((a, b) => a.price - b.price);

    obj = combine(bids,hidden,collateral,denomination.toLowerCase(),earliestSettleBlock);
    hidden = obj.hidden;
    let filterDemand = obj.orders.sort((a, b) => b.price - a.price);

    dispatch({
      type: SET_HIDDEN,
      payload:hidden
    });

    dispatch({
      type: FETCHED_SUB_DEMAND_OFFERS,
      payload:{offers:filterOffers,demand:filterDemand}
    });

  }
  catch(err){
    console.log({err})
  }
}

export function filterHistoricalOrdersDispatch(){
  return (dispatch,getState) => filterHistoricalOrders(dispatch,getState())
}

export function filterHistoricalOrders(dispatch,state){
  try {
    let allOrders = state.orderbook.past_orders.concat(state.orderbook.matched_orders);
    let {denomination,asset,type} = state.ui_marketplace.market;

    let low = Infinity;
    let high = '';
    let volume = 0;
    let change = '';
    let lastPrice = ''

    let orders = allOrders.filter((o)=>{return (
      o.maker.receivesToChain === denomination && o.maker.sendsFromChain === asset ||
      o.maker.sendsFromChain === denomination && o.maker.receivesToChain === asset
    )}).sort((a,b)=>a.timestamp-b.timestamp).map(o=>{
      if(o.price < low) low = o.price;
      if(o.price > high) high = o.price;
      volume += o.price*o.amount
      return o;
    });

    if(volume != 0) volume+= ' ' + asset.toUpperCase()
    else volume = ''

    if(orders.length > 0){
      change = (orders[orders.length-1].price - orders[0].price) / orders[0].price * 100 + '%'
      lastPrice = orders[orders.length-1].price
    }

    dispatch({
      type: FETCHED_STATS,
      payload:{low,high,volume,change,lastPrice}
    })

    dispatch({
      type: FETCHED_SUB_HISTORY,
      payload:orders
    })

  }
  catch(err){
    console.log({err})
  }
}

let combine = (arr,hidden,collateral,denomination,earliestSettleBlock) => {
  let hash = {};

  arr = arr.filter(a => {
    hidden = !(a.collateralizedNrg <= collateral && a.tradeHeight + a.deposit > earliestSettleBlock) ? hidden + 1 : hidden
    return a.collateralizedNrg <= collateral && a.tradeHeight + a.deposit > earliestSettleBlock;
  });

  arr.forEach((a)=>{
    if(hash[a.price]){
      hash[a.price] = {amount:hash[a.price].amount + parseFloat(a.amount),orders:hash[a.price].orders.concat([a])}
    }
    else {
      hash[a.price] = {amount:parseFloat(a.amount),orders:[a]}
    }
  });

  let orders = [];
  Object.keys(hash).forEach((price)=>{
    if(arr.length > 0){
      orders.push({price:price,amount:hash[price].amount,type:arr[0].type,orders:hash[price].orders});
    }
  });

  return {hidden,orders};
}
